module.exports = __webpack_public_path__ + "static/image/history/m/202106@3x.jpg?336cb937";